module.exports = __webpack_public_path__ + "static/img/customise-icon.a545156.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/customise-icon.png
// module id = ATmu
// module chunks = 1